import styled from "styled-components";

import { ITextArea } from "@/components/ui/TextArea/TextArea";

export const StyledTextAreaContainer = styled.div<
  Pick<ITextArea, "$marginbottom" | "$borderColor" | "required" | "$borderRadius">
>`
  display: block;
  position: relative;
  width: 100%;
  border-radius: 0.625rem;
  margin-bottom: ${({ $marginbottom }) => $marginbottom};
  height: fit-content;

  textarea {
    display: block;
    width: 100%;
    box-sizing: border-box;
    border: ${({ $borderColor }) => `1px solid ${$borderColor ?? "gray"}`};
    transition: 0.3s;
    padding: 0.5rem 1rem;
    border-radius: ${({ $borderRadius }) => $borderRadius};

    &:focus {
      outline: none;
      color: ${({ color }) => color ?? "var(--black700)"};
    }

    &:disabled {
      background-color: var(--disabledInput, #f5f5f5);
      cursor: not-allowed;
      border: 1px solid var(--disabledInput, #f5f5f5);
      color: var(--neutral400, #b3b3b3);
    }
  }

  label {
    color: var(--inputLabelColor, #000);
    font-size: 14px;
    text-align: left;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.125rem;
    position: relative;
    line-height: 1;
    margin-bottom: 0.5rem;
    ${({ required }) =>
      required
        ? ` &::after {
        content: '*';
        color: red;
      }`
        : ""};
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    left: 0;
    bottom: -1rem;
    width: 100%;

    .error {
      font-size: 12px;
      color: var(--error, #eb5757);
      padding: 0;
      margin: 0;
      line-height: 1;
    }

    .text-count {
      font-size: 12px;
      color: var(--labelColor, #000);
      padding: 0;
      margin: 0;
      line-height: 1;
      margin-left: auto;
    }
  }
`;
